var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPoints(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3240_21579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.18516 13.3703C5.33064 13.3703 6.25923 12.4417 6.25923 11.2962C6.25923 10.1508 5.33064 9.22217 4.18516 9.22217C3.03968 9.22217 2.11108 10.1508 2.11108 11.2962C2.11108 12.4417 3.03968 13.3703 4.18516 13.3703Z",
    fill: "#537171"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8148 13.3703C18.9603 13.3703 19.8889 12.4417 19.8889 11.2962C19.8889 10.1508 18.9603 9.22217 17.8148 9.22217C16.6693 9.22217 15.7407 10.1508 15.7407 11.2962C15.7407 12.4417 16.6693 13.3703 17.8148 13.3703Z",
    fill: "#537171"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 13.3703C12.1455 13.3703 13.0741 12.4417 13.0741 11.2962C13.0741 10.1508 12.1455 9.22217 11 9.22217C9.8545 9.22217 8.9259 10.1508 8.9259 11.2962C8.9259 12.4417 9.8545 13.3703 11 13.3703Z",
    fill: "#537171"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3240_21579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.7778,
    height: 4.14815,
    fill: "white",
    transform: "translate(2.11108 9.22217)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoints);
export default __webpack_public_path__ + "static/media/points.617cdcb6f54b83d608a18b183cfdda94.svg";
export { ForwardRef as ReactComponent };